import { patch } from '../utils/http';

export const patchPrivateShareToken = (token) =>
  patch(`privateaccess?token=${token}`)
    .then((response) => [null, response])
    .catch((error) => [error, null]);
